import React, { useEffect } from 'react';
import * as S from './Popover.style';

interface PopoverProps {
  message: string | undefined;
  onClose?: () => void;
  duration?: number;
  position?: 'bottom' | 'top' | 'center';
  backgroundColor?: string;
}

export const Popover: React.FC<PopoverProps> = ({
  message,
  onClose,
  duration = 2500,
  position = 'bottom',
  backgroundColor,
}) => {
  useEffect(() => {
    if (message) {
      const timeout = setTimeout(() => {
        onClose?.();
      }, duration);
      return () => clearTimeout(timeout);
    }
  }, [message, onClose, duration]);

  return (
    <S.Popover
      className={message ? 'visible' : ''}
      position={position}
      backgroundColor={backgroundColor}
    >
      <span>{message}</span>
    </S.Popover>
  );
};
